import React, { FC, PropsWithChildren, useCallback } from 'react';
import { ErrorBoundary } from '../shared/util';
import { APP_MANAGER_ORIGIN } from './constants/constants';
import { ErrorState } from './AppManagerContainer/components';

interface AppManagerErrorBoundaryProps extends PropsWithChildren {}

export const AppManagerErrorBoundary: FC<AppManagerErrorBoundaryProps> = ({
  children,
}) => {
  return (
    <ErrorBoundary
      ravenConfig={{
        tags: {
          [APP_MANAGER_ORIGIN]: true,
        },
      }}
      renderError={(errorData) => <ErrorState error={errorData} width={366} />}
    >
      {children}
    </ErrorBoundary>
  );
};
